module.exports = __webpack_public_path__ + "static/media/about-2.e5ae11aa.jpg";